import React, { FC } from 'react'
import { Illustration, IllustrationProps } from '@pandiafi/design-system'
import classNames from 'classnames'

const resolveFillColor = () => {
  const uiTheme = import.meta.env.VITE_UI_THEME

  switch (uiTheme) {
    case 'ta':
      return 'text-brand-7'
    default:
      return 'text-brand-6'
  }
}

export const ResidentAppIllustration: FC<IllustrationProps> = ({
  className,
  ...props
}) => {
  return (
    <Illustration
      className={classNames(className, resolveFillColor())}
      {...props}
    />
  )
}
